import { useEffect, useState } from 'react';
import { takeSilentSignIn } from '../lib/authAccount';
import { useSignedIn } from './useSignedIn';

// L'app revient connectee sans que personne n'ait rien tape : le lien personnel
// ouvert dans l'app installee (useInviteLink recharge la webview), et demain le
// referrer d'installation Android. Dans les deux cas la session change pendant
// que l'ecran est noir, et sans un mot au retour la personne joue sur un compte
// dont elle ignore l'adresse -- celle-la meme qui porte son acces.
//
// Le toast attend que la session soit lue : au premier rendu qui suit le
// rechargement, getSessionUser n'a pas encore repondu.

// La marque ne se lit qu'une fois par session de webview. Au niveau module,
// donc partagee par tous les montages : StrictMode monte deux fois, et le
// second montage ne doit pas trouver la marque deja consommee et rester muet.
let taken = null;

function readOnce() {
  if (taken === null) taken = takeSilentSignIn();
  return taken;
}

// Sortie de test uniquement : les modules gardent leur etat entre deux tests.
export function _resetSilentSignInToast() {
  taken = null;
}

export function useSilentSignInToast() {
  const { user, signedIn } = useSignedIn();
  const [notice, setNotice] = useState(null); // { severity, message }

  useEffect(() => {
    if (!readOnce() || !signedIn || !user?.email) return;
    // Consommee a l'annonce, pas au montage : Supabase re-emet la session au
    // rafraichissement du jeton et au retour sur l'onglet, avec un nouvel objet
    // user a chaque fois. Sans ca, le toast que l'utilisateur a ferme revient
    // une heure plus tard.
    taken = false;
    setNotice({ severity: 'success', message: `Signed in as ${user.email}` });
  }, [signedIn, user]);

  return { notice, dismissNotice: () => setNotice(null) };
}

export default useSilentSignInToast;
